import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as raasiAction from "../KattamAction";
import * as _ from "lodash";
import { withRouter } from "react-router-dom";
import PlanetStrength from "./HouseStrength";
import { ThreeSixtyOutlined } from "@material-ui/icons";
import HouseStrength from "./HouseStrength";

export class HouseStrengthContainer extends React.Component {

  render() {
    if (_.isEmpty(this.props.houseStrength)) {
      return <div>EMPTY</div>
    }
    return (
      <HouseStrength
        data={this.props.houseStrength}
        // profile={this.props.user}
        // raasiBand={this.props.raasiBand}
        // actions={this.props.actions}
      />
    );
  }
}

const mapStateToProps = (state) => {
  let isRaasi = !_.get(state.raasi, "switcher.checked")
  return {
    user: _.get(state.raasi, "currentUser"),
    houseStrength:isRaasi? _.get(state.raasi, "houseStrength", {}) :  _.get(state.raasi, "kotcharamHouseStrength", {})
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(raasiAction, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HouseStrengthContainer));
